/*!

=========================================================
* Now UI Dashboard React - v1.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/now-ui-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// javascript plugin used to create scrollbars on windows
import PerfectScrollbar from "perfect-scrollbar";

// reactstrap components
import { Route, Switch, Redirect } from "react-router-dom";

// core components
import DemoNavbar from "components/Navbars/DemoNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import FixedPlugin from "components/FixedPlugin/FixedPlugin.js";
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import { Card, CardHeader, CardBody, Row, Col } from "reactstrap";
import routes from "routes.js";

import url from "variables/url.js";
import { setCookie, getCookie, checkCookie } from "variables/espolAds.js";
import CasClient, { constant } from "react-cas-client";
import { authService } from './../services/auth.service';
const CAS_PARAMS = url.cas.split("://");
const casOptions = { version: constant.CAS_VERSION_2_0, path: '/', protocol: CAS_PARAMS[0] };
const casClient = new CasClient(CAS_PARAMS[1], casOptions);

var ps;

class Dashboard extends React.Component {
  state = {
      backgroundColor: "blue",
      //username: null,
      //currentUser: null
  };
  mainPanel = React.createRef();
  componentDidMount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(this.mainPanel.current);
      document.body.classList.toggle("perfect-scrollbar-on");
      }
      
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf("Win") > -1) {
      ps.destroy();
      document.body.classList.toggle("perfect-scrollbar-on");
      }      
  }
    componentDidUpdate(e) {
         
  }
  handleColorClick = (color) => {
    this.setState({ backgroundColor: color });
  };
  render() {
    return (
      <div className="wrapper">
        <Sidebar
          {...this.props}
          routes={routes}
          backgroundColor={this.state.backgroundColor}
        />
        <div className="main-panel" ref={this.mainPanel}>
          <DemoNavbar {...this.props} />
          <Switch>
            {routes.map((prop, key) => {
              return (
                <Route
                  path={prop.layout + prop.path}
                  /*path={prop.path}*/
                  component={prop.component}
                  key={key}
                />
              );
            })}
            {/*<Redirect from="/admin" to="/admin/principal" />*/}
                </Switch>
                {/*<PanelHeader size="sm" />*/}
                {/*<div className="content">*/}
                    <Row>
                        <Col md={12}>
                            <Card>
                                {this.props.children}                               
                            </Card>
                        </Col>
                    </Row>
                {/*</div>*/}
                <Footer fluid />                
        </div>
            
      </div>
    );
  }
}

export default Dashboard;
